import { useEffect } from "react";
import ErrorSymbol from "../svgs/ErrorSymbol";
type SnackbarProps = {
  text: string;
  cleanErrorTimeout: () => any;
};
const Snackbar = ({ text, cleanErrorTimeout }: SnackbarProps) => {
  useEffect(() => {
    setTimeout(cleanErrorTimeout, 3500);
  }, []);
  return (
    <div className="snackbar">
      <ErrorSymbol className={"snackbar__icon"} />
      {text}
    </div>
  );
};

export default Snackbar;
